import React, { useContext } from "react"
import styled from "styled-components"
import { useAllowPreviews } from "../../shared/hooks/useAllowPreviews"
import GameContext from "../../../Context/GameContext"
import { lightenColor } from "../../shared/player/lightenColor"

const Wrap = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
`

const ResourceCurrentValue = styled.div`
  background-color: ${props =>
    props?.preview ? props.lighterColor : props.color};
  color: white;
  border-radius: 15px;
  padding: 0px 5px;
  transition: color 0.8s, background-color 0.8s;
`

const PreviewGroup = styled.div`
  display: flex;
  width: ${props => (props.showPreview ? "50px" : "0px")};
  overflow: hidden;
  transition: width 0.5s;
  align-items: center;
`

const ResourcePreviewValue = styled.div`
  color: white;
  background-color: ${props => props.color};
  border-radius: 15px;
  padding: 0px 5px;
`

const ToIcon = styled.div`
  width: 20px;
  margin: 2px -5px;
  color: ${props => props.color || "white"};
`

export const ResourceValue = ({ player }) => {
  const { gameData } = useContext(GameContext)
  const color = player?.role?.color
  const lighterColor = color ? lightenColor(color, 60) : "transparent"
  const current = player?.energy?.current || 0
  const preview = player?.energy?.preview || 0
  const unit = gameData?.game_resource?.unit
  const allowPreview = useAllowPreviews()
  const showPreview = current !== preview && allowPreview

  // if (current >= 0)
  return (
    <Wrap>
      <ResourceCurrentValue
        preview={showPreview}
        color={color}
        lighterColor={lighterColor}
        children={`${current}${unit}`}
      />

      <PreviewGroup showPreview={showPreview}>
        <ToIcon color={color} aria-disabled="true" aria-hidden="true">
          {">"}
        </ToIcon>
        <ResourcePreviewValue
          color={color}
          children={`${preview}${unit}`}
          aria-disabled="true"
          aria-hidden="true"
        />
      </PreviewGroup>
    </Wrap>
  )
  // else return null
}
